import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { JoinPipe } from './join/join.pipe';
import { PluckPipe } from './pluck/pluck.pipe';
import { TypeofPipe } from './typeof/typeof.pipe';
import { SafehtmlPipe } from './safehtml/safehtml.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { PaginationComponent } from './pagination/pagination.component';

// P-LOC · LOC-2/LOC-3 — ONE location tree for the whole platform.
// It lives here because user.module and vadmin.module both already import UtilityModule,
// and a second tree component would immediately start drifting from the first — which is
// precisely the bug (UI meaning one thing, backend meaning another) this tree exists to fix.
// It owns no API: the caller passes a `source`, so vadmin can read the global master while
// the org screens read their own scope.
import { LocationTreeComponent } from './location-tree/location-tree.component';

// DE-6 — i18n. The pipe (`| t`) and the switcher live here so they are available in EVERY module
// that already imports UtilityModule — user, vadmin, and (DE-7) the public survey page.
// A new language is a DB row, not a code change: see services/i18n.service.ts.
import { TranslatePipe } from './i18n/translate.pipe';
import { LanguageSwitcherComponent } from './i18n/language-switcher.component';


@NgModule({
  declarations: [
    JoinPipe,
    PluckPipe,
    TypeofPipe,
    SafehtmlPipe,
    TruncatePipe,
    PaginationComponent,
    LocationTreeComponent,
    TranslatePipe,
    LanguageSwitcherComponent,
  ],
  imports: [
    FormsModule,
    CommonModule
  ],
  exports: [
    JoinPipe,
    PluckPipe,
    TypeofPipe,
    SafehtmlPipe,
    TruncatePipe,
    PaginationComponent,
    LocationTreeComponent,
    TranslatePipe,
    LanguageSwitcherComponent
  ]
})
export class UtilityModule { }
